import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";
import {AuthenticationMethodType} from "@vesta/vos-types/modules/platformLevel/authentication/domain/AuthenticationMethodType";

export type AdminAuthenticationMethod = {
    id: Uuid;
    userId: Uuid;
    type: AuthenticationMethodType;
    typeSpecificData: Record<string, unknown>;
    createdAt: Iso8601DateTime;
    updatedAt: Iso8601DateTime;
};

const authenticationMethodTypeValues = Object.values(AuthenticationMethodType) as [
    AuthenticationMethodType,
    ...Array<AuthenticationMethodType>,
];

export const adminAuthenticationMethodValidator = zod.object({
    id: uuidZodValidator,
    userId: uuidZodValidator,
    type: zod.enum(authenticationMethodTypeValues),
    typeSpecificData: zod.record(zod.string(), zod.unknown()),
    createdAt: iso8601DateTimeZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
});

export function formatAuthenticationMethodTypeSpecificData(
    type: AuthenticationMethodType,
    typeSpecificData: Record<string, unknown>,
): string {
    switch (type) {
        case AuthenticationMethodType.impersonate:
            return "-";
        case AuthenticationMethodType.otpViaEmail:
        case AuthenticationMethodType.ssoViaGoogle:
            return typeof typeSpecificData.email === "string" ? typeSpecificData.email : "-";
        case AuthenticationMethodType.otpViaSms:
            return typeof typeSpecificData.phoneNumber === "string" ? typeSpecificData.phoneNumber : "-";
        case AuthenticationMethodType.passwordViaEmail:
            return typeof typeSpecificData.email === "string" ? typeSpecificData.email : "-";
        case AuthenticationMethodType.ssoViaMicrosoft:
            return typeof typeSpecificData.id === "string" ? typeSpecificData.id : "-";
        default:
            return "-";
    }
}
